module.exports = __webpack_public_path__ + "media/audiosprite.98ee3abd.ogg";